// CANONICAL COPY (GH #7115). src/constants/obligations/obl-security-testing.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-security-testing',
  title: 'Perform application security testing',
  description:
    'Execute security testing (static analysis, dynamic analysis, or targeted review) during development and before release to validate that security requirements have been met and vulnerabilities addressed.',
  category: 'technical',
  scfIds: ['SCF-DEV-005'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Security testing procedure or report is published',
    },
    {
      type: 'manual-attestation',
      description: 'Confirm security testing was actually performed before the last release',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
